<div class="users-table-container">
  @if (loading) {
    <div class="flex justify-center items-center h-64">
      <p-progressSpinner />
    </div>
  }
  @if (!loading) {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
    >
      <div
        class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-5 py-3 dark:border-gray-700 dark:bg-gray-800/70"
      >
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Mostrando
          <span class="font-semibold text-gray-900 dark:text-gray-100">{{ users.length }}</span>
          {{ users.length === 1 ? 'usuario' : 'usuarios' }}
        </p>
      </div>

      <p-table
        (onLazyLoad)="onPageChange($event)"
        [currentPageReportTemplate]="
          'usersModule.pagination'
            | translate
              : {
                  first: '{first}',
                  last: '{last}',
                  totalRecords: '{totalRecords}',
                }
        "
        [first]="first"
        [globalFilterFields]="['name', 'email']"
        [lazy]="true"
        [loading]="loading"
        [paginatorDropdownAppendTo]="'body'"
        [paginator]="true"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [rows]="rows"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '50rem' }"
        [totalRecords]="totalRecords"
        [value]="users"
        styleClass="users-table"
      >
        <ng-template #caption>
          <div class="flex flex-col gap-3 md:flex-row md:items-center md:gap-4">
            <div class="relative w-full md:flex-1">
              <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                (input)="onSearchInput($any($event.target).value)"
                [placeholder]="'usersModule.searchingUsers' | translate"
                [value]="searchTerm"
                class="h-9 w-full min-w-0 pl-10! pr-10"
                pInputText
                type="text"
              />
              @if (searchTerm) {
                <button
                  (click)="onSearchClear()"
                  class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  type="button"
                >
                  <i class="pi pi-times"></i>
                </button>
              }
            </div>

            <div
              class="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 md:flex md:w-auto md:items-center"
            >
              <p-select
                (onChange)="onStatusChange($event.value)"
                [ngModel]="selectedStatus"
                [options]="statusOptions"
                [placeholder]="'usersModule.status' | translate"
                class="w-full sm:min-w-[190px]"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
              >
                <ng-template let-option pTemplate="item">
                  <div class="flex items-center gap-2">
                    <i [class]="option.icon" class="text-sm"></i>
                    <span>{{ option.label | translate }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="selectedItem">
                  @if (selectedStatus) {
                    <div class="flex items-center gap-2">
                      <i
                        [class]="
                          selectedStatus === 'active'
                            ? 'pi pi-check-circle'
                            : selectedStatus === 'inactive'
                              ? 'pi pi-times-circle'
                              : 'pi pi-list'
                        "
                        class="text-sm"
                      ></i>
                      <span>
                        {{
                          selectedStatus === 'active'
                            ? ('usersModule.active' | translate)
                            : selectedStatus === 'inactive'
                              ? ('usersModule.inactive' | translate)
                              : ('usersModule.status' | translate)
                        }}
                      </span>
                    </div>
                  }
                </ng-template>
              </p-select>

              @if (hasActiveFilters()) {
                <p-button
                  (onClick)="onClearFilters()"
                  icon="pi pi-filter-slash"
                  label="Limpiar"
                  severity="secondary"
                  styleClass="w-full sm:w-auto"
                  type="button"
                  variant="outlined"
                />
              }

              <p-button
                (onClick)="onCreateUser()"
                [label]="'usersModule.newUser' | translate"
                icon="pi pi-plus"
                styleClass="w-full whitespace-nowrap sm:w-auto sm:min-w-[168px] md:ml-1"
                type="button"
              />
            </div>
          </div>
        </ng-template>

        <ng-template #header>
          <tr class="bg-gray-50 text-xs font-semibold uppercase tracking-wide dark:bg-gray-800/70">
            <th scope="col">ID</th>
            <th scope="col">
              {{ 'usersModule.name' | translate }}
            </th>
            <th scope="col">
              {{ 'usersModule.email' | translate }}
            </th>
            <th scope="col">
              {{ 'usersModule.role' | translate }}
            </th>
            <th scope="col">
              {{ 'usersModule.status' | translate }}
            </th>
            <th class="text-center!" scope="col">
              {{ 'common.actions' | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-rowIndex="rowIndex" let-user>
          <tr
            [ngClass]="
              rowIndex % 2 === 0 ? 'bg-white dark:bg-gray-900' : 'bg-gray-50/60 dark:bg-gray-800/30'
            "
            class="transition-colors hover:bg-primary-50/40 dark:hover:bg-primary-900/10"
          >
            <td class="py-4 pl-6">
              <span
                class="rounded-md border border-gray-200 bg-gray-100 px-2 py-0.5 font-mono text-xs font-semibold text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
              >
                #{{ user.id }}
              </span>
            </td>
            <td>
              <div class="flex items-center gap-3">
                <div
                  [class]="getAvatarColorClass(user.name)"
                  class="flex size-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
                >
                  {{ getInitials(user.name) }}
                </div>
                <span class="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {{ user.name || 'Sin nombre' }}
                </span>
              </div>
            </td>
            <td>
              <span class="text-sm text-gray-500 dark:text-gray-400">
                {{ user.email || 'Sin correo' }}
              </span>
            </td>
            <td>
              <div class="flex flex-wrap gap-1.5">
                @for (role of getVisibleRoles(user.role); track role) {
                  <span
                    class="inline-flex items-center rounded-md border border-primary-200 bg-primary-50 px-2 py-0.5 text-xs font-medium text-primary-700 dark:border-primary-800 dark:bg-primary-900/20 dark:text-primary-300"
                  >
                    {{ role }}
                  </span>
                }
                @if (getHiddenRolesCount(user.role) > 0) {
                  <span
                    [pTooltip]="getHiddenRolesText(user.role)"
                    class="inline-flex cursor-default items-center rounded-md border border-gray-200 bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600 dark:border-gray-700 dark:bg-gray-700 dark:text-gray-300"
                    tooltipPosition="top"
                  >
                    +{{ getHiddenRolesCount(user.role) }}
                  </span>
                }
                @if (getVisibleRoles(user.role).length === 0) {
                  <span class="text-xs text-gray-400">Sin rol</span>
                }
              </div>
            </td>
            <td>
              @if (user.is_active) {
                <span
                  class="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-100 px-2.5 py-1 text-xs font-medium text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300"
                >
                  <i class="pi pi-check-circle text-[10px]"></i>
                  Activo
                </span>
              } @else {
                <span
                  class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600 dark:border-gray-700 dark:bg-gray-700 dark:text-gray-300"
                >
                  <i class="pi pi-times-circle text-[10px]"></i>
                  Inactivo
                </span>
              }
            </td>
            <td>
              <div class="flex items-center justify-center gap-1">
                <p-button
                  (onClick)="onEditUser(user)"
                  [ariaLabel]="'common.edit' | translate"
                  [pTooltip]="'common.edit' | translate"
                  [text]="true"
                  icon="pi pi-pencil"
                  severity="secondary"
                  styleClass="size-8 hover:text-primary-600!"
                  tooltipPosition="top"
                />

                <p-button
                  (onClick)="onToggleStatus(user)"
                  [ariaLabel]="user.is_active ? 'Deshabilitar' : 'Habilitar'"
                  [icon]="user.is_active ? 'pi pi-ban' : 'pi pi-check'"
                  [pTooltip]="user.is_active ? 'Deshabilitar' : 'Habilitar'"
                  [styleClass]="
                    user.is_active
                      ? 'size-8 hover:text-amber-600! hover:bg-amber-50!'
                      : 'size-8 hover:text-emerald-600! hover:bg-emerald-50!'
                  "
                  [text]="true"
                  severity="secondary"
                  tooltipPosition="top"
                />

                <p-button
                  (onClick)="onDeleteUser(user)"
                  [ariaLabel]="'usersModule.deleteUser' | translate"
                  [pTooltip]="'usersModule.deleteUser' | translate"
                  [text]="true"
                  icon="pi pi-trash"
                  severity="secondary"
                  styleClass="size-8 hover:text-red-600! hover:bg-red-50!"
                  tooltipPosition="top"
                />
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td class="py-16 text-center text-sm text-gray-500 dark:text-gray-400" colspan="6">
              No se encontraron usuarios con los filtros aplicados.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
